class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.searchForColors = this.searchForColors.bind(this);
  }
  connectedCallback() {
    this.collectionColorTag = this.getAttribute("data-collection-color-tag") || void 0;
    this.colorsSelector = this.getAttribute("data-colors-selector") || "";
    this.addEventListener("click", this.onClick);
    if (!this.collectionColorTag) return;
    if (!this.colorsSelector) return;
    this.colorsEl = this.querySelector(this.colorsSelector);
    if (!this.colorsEl) return;
    this.addEventListener("mouseover", this.searchForColors);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }
  onClick() {
    onClickOnProductCard(this);
  }
  async searchForColors() {
    if (!this.colorsEl.innerHTML) {
      const query = encodeURIComponent(`tag:"${this.collectionColorTag}"`);
      const url = `/search?resources[type]=product&section_id=product-card-colors&t=${Date.now()}&q=${query}`;
      try {
        const response = await fetch(url, { cache: "force-cache" });
        const responseText = await response.text();
        this.colorsEl.innerHTML = responseText;
      } catch (error) {
        console.error("[ProductCard]", error.message);
      }
    }
  }
}
if (customElements.get("w3-product-card") === void 0) {
  customElements.define("w3-product-card", ProductCard);
}
function onClickOnProductCard(element) {
  const page = element.getAttribute("data-origin-page");
  if (page) {
    const newUrl = new URL(window.location.href);
    if (page === "1") {
      newUrl.searchParams.delete("page");
    } else {
      newUrl.searchParams.set("page", page);
    }
    history.replaceState(null, "", newUrl.toString());
  }
}
export {
  onClickOnProductCard as o
};
